import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { PaymentContext } from '@carm/_core/payments/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ENROLLMENT_DRAFT_ID, MonerisResponse, PAYMENT_CONTEXT } from '../models/moneris.model';

@Injectable()
export class MonerisService extends BaseApiService {

  constructor(protected injector: Injector,
    private route: ActivatedRoute) {
    super(injector);
  }

  public startMonerisCheckout(amount: string, store: string): Observable<string> {
    const monerisBaseUrl = this.getMonerisPaymentBaseUrl();
    const endpoint = `${monerisBaseUrl}/preload`;
    const dataToSend = {
      amount,
      store
    };
    return this.httpAuthPost<any>(endpoint, dataToSend).pipe(
      map(data => {
        return data.ticket;
      })
    );
  }

  public getCreditAmountRemaining(): Observable<string> {
    const monerisBaseUrl = this.getMonerisPaymentBaseUrl();
    const endpoint = `${monerisBaseUrl}/credit-amount`;
    return this.httpAuthPost<any>(endpoint, null).pipe(
      map(data => {
        return data ? data.availableCredit: "0";
      })
    );
  }

  public updateCheckout(): Observable<MonerisResponse> {
    const monerisBaseUrl = this.getMonerisPaymentBaseUrl();
    const endpoint = `${monerisBaseUrl}/update`;
    const dataToSend = {
      ticket: this.checkoutTicket
    };
    return this.httpAuthPost<MonerisResponse>(endpoint, dataToSend);
  }

  public get checkoutTicket(): string {
    return this.route.snapshot.queryParamMap.get('t');
  }

  public get checkoutInProgress(): boolean {
    return !!this.checkoutTicket;
  }

  private getMonerisPaymentBaseUrl(): string {
    const paymentContext = localStorage.getItem(PAYMENT_CONTEXT) as PaymentContext;
    let draftId = localStorage.getItem(ENROLLMENT_DRAFT_ID) as string;
    let endPoint = null;

    switch (paymentContext) {
      case PaymentContext.Business:
        endPoint = `${this.endPointB}/moneris/mco/enrolment/${draftId}`;
        break;
      case PaymentContext.Program:
        endPoint = `${this.endPointBP}/moneris/mco`;
        break;
      case PaymentContext.Orphan:
        endPoint = `${environment.baseApiUrls}/moneris/mco/enrolment/${draftId}`;
        break;
    }

    // handled online payment, where draftId is not provided, default payment against program
    if (!draftId){
      endPoint = `${this.endPointBP}/moneris/mco`;
    }

    return endPoint;
  }
}
